import { render, staticRenderFns } from "./tjhcRkDialog.vue?vue&type=template&id=0e04ff53&scoped=true&"
import script from "./tjhcRkDialog.vue?vue&type=script&lang=js&"
export * from "./tjhcRkDialog.vue?vue&type=script&lang=js&"
import style0 from "./tjhcRkDialog.vue?vue&type=style&index=0&id=0e04ff53&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e04ff53",
  null
  
)

export default component.exports